import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {BodyMeasurementsDependencies} from '../dependencies';
import {keys} from './keys';

export type ListBodyMetricsQueryDependencies = Pick<BodyMeasurementsDependencies, 'controllers'>;

export const listBodyMetricsQuery = ({controllers}: ListBodyMetricsQueryDependencies) =>
  queryOptions({
    queryKey: keys.metrics(),
    queryFn: () => controllers.bodyMeasurementsController.listMetrics().then(unwrap),
  });
